module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[62]183.3039933.woff2";